import { CircleProgressIndicator as Base } from './CircleProgressIndicator';

export const CircleProgressIndicator = Object.assign(Base, {
    displayName: 'CircleProgressIndicator',
});

export type { CircleProgressIndicatorProps } from './CircleProgressIndicator';
